<div
  class="header-secondary"
  [ngClass]="{
    'prek2-reading-header': activityService.isPreK2ReadingActivity()
  }"
  data-testid="htc-header-secondary">
  <span class="header-secondary-number" data-testid="htc-episode-number">
    @if (!activityService.isPreK2ReadingActivity() && episode !== '0') {
      {{ 'SUB_HEADER.EPISODE' | translate }} {{ episode }}
    }
  </span>
  @if (showProgressBar) {
    <htc-progress-bar
      class="header-secondary-progress"
      [nodes$]="pageProgressService.progressService.shownNodes$"
      [config]="pageProgressService.progressService.Config"
      (clickedEvent)="onProgressNodeClick($event)"
      [enabled]="progressBarEnabled"
      data-testid="htc-progress-bar">
    </htc-progress-bar>
  }
  @if (showElapsedTime) {
    <htc-time-elapsed
      class="header-secondary-time"
      data-testid="htc-elapsed-time"></htc-time-elapsed>
  }
</div>
